import { defineVuePlugin } from '#/vue-plugins'
import { Notify, Quasar } from 'quasar'
import quasarLangEn from 'quasar/lang/en-US'

export default defineVuePlugin(async (app) => {
  app.use(Quasar, {
    lang: quasarLangEn,
    plugins: {
      Notify,
    },
    config: {
      dark: false,
    },
  })
})
